import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import moment from "moment";
import { labelStyles } from "./constants";
import {getFilterCount} from "../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";

const FilterForm = ({
  closePopup,
  dropdownData,
  filterForm,
  filterCount,
  setFilterCount,
  setFilterForm,
  applyFilterHandler,
  forPANIndia
}) => {
  //destructuring dropdown prop to get all dropdowns
  const {
    allActiveBu: businessAreas,
    allActiveRegions,
    allActiveCareers,
  } = dropdownData;

  // apply filter callback
  const handleApplyFilter = () => {
    let fCount = getFilterCount({ ...filterForm });
    setFilterCount(fCount);
    //call search api
    applyFilterHandler(0, filterForm);
    closePopup();
  };

  //reset filter form
  const resetFilterForm = () => {
    setFilterCount(0);
    setFilterForm({});
    //call api to fetch list
    applyFilterHandler();
    closePopup();
  };

  // works as onChange Handler
  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="mb-1 d-flex align-items-start justify-content-between">
          <div className="regular-large-bold">Filters</div>
        </div>

        <div className="d-flex flex-column gap-md">
          {
            !forPANIndia && <AAutoComplete
              label="Business area"
              currentValue={filterForm?.businessArea}
              items={businessAreas}
              handleChange={(value) => {
                filterFormHandler("businessArea", value);
              }}
              selectAllMenuButton={true}
              isShowCount={true}
              isMulti={true}
            />
          }

          <AAutoComplete
            label="Career"
            currentValue={filterForm?.academicCareer}
            items={allActiveCareers}
            handleChange={(value) => {
              filterFormHandler("academicCareer", value);
            }}
            selectAllMenuButton={true}
            isShowCount={true}
            isMulti={true}
          />

          <div style={labelStyles}>Ticket Id</div>
          <AInput
            type="text"
            value={filterForm?.ticketId}
            handler={(value) => {
              filterFormHandler("ticketId", value);
            }}
            placeholder="Enter"
          />

          <div style={labelStyles}>Receipting Date</div>
          <div className={"d-flex flex justify-content-between"} style={{columnGap : '10px'}}>
            <CustomDatePickerV2
              placeHolder="From"
              maxDate={moment(new Date())}
              value={filterForm?.startDate}
              width={"18px"}
              handler={(index, date, keyName) => {
                filterFormHandler("startDate", moment(date).startOf('day'));
                filterFormHandler("endDate", moment(new Date()).endOf('day'));
              }}
            />
            <CustomDatePickerV2
              placeHolder="To"
              width={"18px"}
              maxDate={moment(new Date())}
              value={filterForm?.endDate}
              handler={(index, date, keyName) => {
                filterFormHandler("endDate", moment(date).endOf('day'));
              }}
            />
          </div>
        </div>
        <div className="mt-3 d-flex flex-row-reverse justify-content-between">
          <AButton
            variant="primary_filled"
            className="button_remove_left_margin"
            onClick={() => {
              handleApplyFilter();
            }}
            disabled={getFilterCount({ ...filterForm }) == 0}
          >
            Apply filter
          </AButton>

          {filterCount > 0 && (
            <AButton
              variant="outline"
              className="button_remove_left_margin"
              updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
              onClick={resetFilterForm}
            >
              Remove filter
            </AButton>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default FilterForm;
